import querystring from 'querystring';
import axios from 'axios';
import { API } from '../utils/constants';

const resources = {
  solutionChildren: 'geographicsolutionchildren?',
  locationPrices: 'locationprices?',
  locations: 'solutionbuilderlocations?',
};

export const getGeoLocationData = async (geoLocationId = '', language = '') => {
  const params = querystring.encode({ ctx: geoLocationId, lang: language });
  const url = `${API.SOLUTION_BUILDER}${resources.solutionChildren}${params}`;
  const response = await axios
    .get(url)
    .then(({ data }) => ({ data, error: null }))
    .catch(error => ({ data: null, error }));

  return response;
};

export const getProductIdLocationsPrices = (
  countryIsoCode,
  GeoSolutions,
  PriceUnitId,
  ProductUsageDays,
  Term,
  ProductTypeId,
  ProductVariants = 0,
) => {
  const params = querystring.encode({
    countryIsoCode,
    GeoSolutions,
    PriceUnitId,
    ProductUsageDays,
    Term,
    ProductTypeId,
    ProductVariants,
  });
  const url = `${API.SOLUTION_BUILDER}${resources.locationPrices}${params}`;
  return axios
    .get(url)
    .then(({ data }) => ({ data, error: null }))
    .catch(error => ({ data: null, error }));
};

export const getLocationsData = (locationIds = [], lang = '') => {
  const params = querystring.encode({
    ctx: locationIds.join('|'),
    lang,
  });
  const url = `${API.SOLUTION_BUILDER}${resources.locations}${params}`;
  return axios
    .get(url)
    .then(({ data }) => ({ data, error: null }))
    .catch(error => ({ data: null, error }));
};
